import type { TWeekDaysKeys } from 'shared/lib/dictionaries/week-days'
import type { IDeliveryArea } from 'shared/model/search-product.dto'
import { Mask } from 'maska'
import { WEEK_DAYS } from 'shared/lib/dictionaries/week-days'

type MaskType = string | string[] | ((input: string) => string) | null
interface MaskOptions {
  mask?: MaskType
  eager?: boolean // при вводе "7" прокидывает в инпут '+7(7'
}

export function phoneForAPI(value: string): string {
  if (!value)
    return ''

  return (
    value
      .toString()
      .replace(/^.{2}(.*)/, '$1') // удаляет первые два символа из строки.
      .replace(/[()+-]/g, '') || '' //  удаляет все указанные знаки из строки.
  )
}

export function getMaskedValue(config: MaskOptions, value: string): string {
  const initMask = new Mask(config)

  return initMask.masked(value.toString())
}

export function formatPhoneDisplay(value: string): string {
  const digits = value.toString().replace(/\D/g, '')

  return `+${digits.length === 10 ? `7${digits}` : digits}`
}

export function formatDeliveryAreaLabel(area?: IDeliveryArea | null): string {
  if (!area || !area.id)
    return ''

  const days = area.available_days?.length
    ? area.available_days
        .map((day: string) => WEEK_DAYS[day as TWeekDaysKeys])
        .join(', ')
    : '-'

  return `${area.name}ㅤ | ㅤ${days}ㅤ |ㅤ ${area.price}₸`
}
